import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect } from "react";
import { getGbFromBytes, getKbMbGbFromBytes } from "src/components/js/statics1";
import YearMonthDropDown from "src/components/YearMonthDropDown/YearMonthDropDown";
import { useStatData } from "src/context/StatContext";

export default function Stat_Hintalaskelmat() {
  const { selectedMonthData, selectedMonth, selectedYear, setSelectedMonth, setSelectedYear } =
    useStatData();
  console.log(selectedMonthData);
  console.log(selectedMonth);

  useEffect(() => {}, [selectedMonthData]);

  const handleMonthChange = (data) => {
    const { year, month } = data;
    setSelectedYear(year);
    setSelectedMonth(month);
  };

  // pumiFi SQL: 50€ / kk
  // pumi.fi sites: 100€ / kk
  // pumi.fi load-balancer: 62€ / kk
  // aws vpc: 50€ / kk
  // lemonsoft palvelin: 110€ / kk
  const googleKate = 1.7; // 70% kate

  const pumiFiPrice = 100;
  const lemonsoftPrice = 150;
  const basePrice = 75;
  const gbPriceHot = 0.15 * googleKate; // 0.15*12€ per GB per month for a storage of 1 year
  const gbPriceCool = 0.03 * googleKate; // 0.01€ per GB per month for storage of the archive
  const vehiclePrice = 4;
  const kuskiPrice = 4;
  const laskuPrice = 0.3;
  const keikkaPrice = 0.25;
  const googleMapsPrice = (7 / 1000) * googleKate; // 0.007€ per google maps request
  const domainYlläpito = 60 / 12; // 60€ / vuosi
  const domainCount = 1;
  const domainHostingCount = 2;
  const domainHosting = 300 / 12; // webflow: 276usd/year

  const totalPrice =
    basePrice +
    pumiFiPrice +
    lemonsoftPrice +
    domainYlläpito * domainCount +
    domainHosting * domainHostingCount +
    selectedMonthData[0]?.laskuCount * laskuPrice +
    selectedMonthData[0]?.keikkaCount * keikkaPrice +
    selectedMonthData[0]?.vehicleCount * vehiclePrice +
    selectedMonthData[0]?.kuskiCount * kuskiPrice +
    selectedMonthData[0]?.googleMapsCount * googleMapsPrice +
    selectedMonthData[0]?.attachmentCount +
    getGbFromBytes(selectedMonthData[0]?.attachmentSize) * gbPriceHot;

  return (
    <div>
      <YearMonthDropDown
        defaultYear={selectedYear}
        defaultMonth={selectedMonth}
        onChange={handleMonthChange}
      />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>TuoteId</TableCell>
              <TableCell>Selite</TableCell>
              <TableCell>kpl</TableCell>
              <TableCell>Yks. hinta / kk</TableCell>
              <TableCell>Hinta / kk</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Betoni.online perushinta</TableCell>
              <TableCell>1</TableCell>
              <TableCell>{basePrice}€</TableCell>
              <TableCell>{basePrice}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Tilausten hallinta</TableCell>
              <TableCell>{selectedMonthData[0]?.keikkaCount}</TableCell>
              <TableCell>{keikkaPrice}€ / tilaus</TableCell>
              <TableCell>{selectedMonthData[0]?.keikkaCount * keikkaPrice}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Ajoneuvojen hallinta</TableCell>
              <TableCell>{selectedMonthData[0]?.vehicleCount}</TableCell>
              <TableCell>{vehiclePrice}€ / ajoneuvo</TableCell>
              <TableCell>{selectedMonthData[0]?.vehicleCount * vehiclePrice}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Lomahallinta</TableCell>
              <TableCell>{selectedMonthData[0]?.kuskiCount}</TableCell>
              <TableCell>{kuskiPrice}€ / kuljettaja</TableCell>
              <TableCell>{selectedMonthData[0]?.kuskiCount * kuskiPrice}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Laskutuspalvelu</TableCell>
              <TableCell>{selectedMonthData[0]?.laskuCount}</TableCell>
              <TableCell>{laskuPrice}€ / lasku</TableCell>
              <TableCell>{(selectedMonthData[0]?.laskuCount * laskuPrice).toFixed(2)}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Liitetiedostot (1 vuosi säilytys)</TableCell>
              <TableCell>
                {selectedMonthData[0]?.attachmentCount}kpl{" "}
                {getKbMbGbFromBytes(selectedMonthData[0]?.attachmentSize)}
              </TableCell>
              <TableCell>{gbPriceHot.toFixed(4)}€ / GB</TableCell>
              <TableCell>
                {(getGbFromBytes(selectedMonthData[0]?.attachmentSize) * gbPriceHot).toFixed(2)}€
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Liitetiedostot (arkisto)</TableCell>
              <TableCell>0</TableCell>
              <TableCell>{gbPriceCool}€ per GB</TableCell>
              <TableCell>0€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Google Maps -käytöt</TableCell>
              <TableCell>{selectedMonthData[0]?.googleMapsCount}</TableCell>
              <TableCell>{googleMapsPrice.toFixed(4)}€ / kpl</TableCell>
              <TableCell>
                {(selectedMonthData[0]?.googleMapsCount * googleMapsPrice).toFixed(2)}€
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Domain ylläpito</TableCell>
              <TableCell>
                <small>kalleurho.fi</small>
              </TableCell>
              <TableCell>{domainYlläpito.toFixed(2)}€ / domain</TableCell>
              <TableCell>{(domainYlläpito * domainCount).toFixed(2)}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Domain hosting</TableCell>
              <TableCell>
                <small>
                  kalleurho.fi
                  <br /> maxbe.fi
                </small>
              </TableCell>
              <TableCell>{domainHosting.toFixed(2)}€ / domain</TableCell>
              <TableCell>{(domainHosting * domainHostingCount).toFixed(2)}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Pumi.fi ylläpito</TableCell>
              <TableCell>1</TableCell>
              <TableCell>{pumiFiPrice}€</TableCell>
              <TableCell>{pumiFiPrice}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Lemonsoft ylläpito</TableCell>
              <TableCell>1</TableCell>
              <TableCell>{lemonsoftPrice}€</TableCell>
              <TableCell>{lemonsoftPrice}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <b>Yhteensä</b>
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <b>{totalPrice.toFixed(2)} €</b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <div className="spaceAround">
        <div>+alv (25,5%): {(totalPrice * 0.255).toFixed(2)}€</div>
        <div>Yhteensä: {(totalPrice * 1.255).toFixed(2)}€</div>
      </div>
    </div>
  );
}
